/* Odorato · Q4. Banner (carrusel), cuenta regresiva, filtros de colección, buscador del encabezado y lista de marcas.
   Todo con delegación de eventos sobre document: sigue funcionando aunque Shopify vuelva a dibujar una sección. */
(function () {
  if (window.__q4) return;
  window.__q4 = true;
  var reducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- Banner ---------------- */
  function pista(raiz) { return raiz.querySelector('[data-q4-pista]'); }
  function total(raiz) { var p = pista(raiz); return p ? p.children.length : 0; }
  function indice(raiz) {
    var p = pista(raiz);
    return p ? Math.max(0, Math.min(total(raiz) - 1, Math.round(p.scrollLeft / Math.max(1, p.clientWidth)))) : 0;
  }
  function marcar(raiz, i) {
    if (i == null) i = indice(raiz);
    raiz.querySelectorAll('[data-q4-ir]').forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
  }
  function ir(raiz, i) {
    var p = pista(raiz), n = total(raiz);
    if (!p || n < 2) return;
    i = ((i % n) + n) % n;
    p.scrollTo({ left: i * p.clientWidth, behavior: reducido ? 'auto' : 'smooth' });
    marcar(raiz, i);
    raiz._q4Ultimo = Date.now();
    raiz._q4Destino = i; raiz._q4DestinoT = Date.now();
  }
  // Si el desplazamiento anterior todavía no termina, se cuenta desde la diapositiva de destino (dos clics seguidos)
  function actual(raiz) { return raiz._q4DestinoT && Date.now() - raiz._q4DestinoT < 900 ? raiz._q4Destino : indice(raiz); }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-q4-banner] [data-q4-ir], [data-q4-banner] [data-q4-ant], [data-q4-banner] [data-q4-sig]');
    if (!b) return;
    var raiz = b.closest('[data-q4-banner]');
    var i = actual(raiz);
    if (b.hasAttribute('data-q4-ant')) ir(raiz, i - 1);
    else if (b.hasAttribute('data-q4-sig')) ir(raiz, i + 1);
    else ir(raiz, parseInt(b.getAttribute('data-q4-ir'), 10) || 0);
    // Flechas y rayas no detienen el paso automático: solo reinician el tiempo (ir() marca _q4Ultimo). Lo detiene la pausa.
  });
  // Botón de pausa (computador): detiene y reanuda el paso automático
  function pintarPausa(raiz) {
    var b = raiz.querySelector('[data-q4-pausa]');
    if (!b) return;
    b.setAttribute('aria-pressed', raiz._q4Pausa ? 'true' : 'false');
    b.setAttribute('aria-label', raiz._q4Pausa ? 'Reanudar el carrusel' : 'Pausar el carrusel');
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-q4-banner] [data-q4-pausa]');
    if (!b) return;
    var raiz = b.closest('[data-q4-banner]');
    raiz._q4Pausa = !raiz._q4Pausa;
    raiz._q4Ultimo = Date.now();
    pintarPausa(raiz);
  });
  document.addEventListener('scroll', function (e) {
    var p = e.target;
    if (!(p instanceof Element) || !p.hasAttribute('data-q4-pista')) return;
    var raiz = p.closest('[data-q4-banner]');
    clearTimeout(p._q4T);
    p._q4T = setTimeout(function () { marcar(raiz); }, 80);
  }, true);
  // Deslizar la foto con el dedo o el mouse detiene el paso automático (en celular no hay botón de pausa)
  document.addEventListener('pointerdown', function (e) {
    var p = e.target.closest && e.target.closest('[data-q4-pista]');
    if (!p) return;
    var raiz = p.closest('[data-q4-banner]');
    raiz._q4Pausa = true;
    pintarPausa(raiz);
  }, true);
  document.addEventListener('keydown', function (e) {
    var p = e.target.closest && e.target.closest('[data-q4-pista]');
    if (!p || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
    e.preventDefault();
    var raiz = p.closest('[data-q4-banner]');
    ir(raiz, indice(raiz) + (e.key === 'ArrowRight' ? 1 : -1));
    raiz._q4Pausa = true;
    pintarPausa(raiz);
  });
  // Paso automático: un solo reloj para todos los banners; se detiene con el mouse encima, al tocar o en otra pestaña.
  setInterval(function () {
    if (document.hidden) return; // con «reducir movimiento» el banner parte en pausa (ver todo()); solo avanza si la persona lo reanuda
    document.querySelectorAll('[data-q4-banner][data-autoplay="true"]').forEach(function (raiz) {
      if (raiz._q4Pausa || raiz.matches(':hover') || total(raiz) < 2) return;
      var seg = Math.max(3, parseInt(raiz.getAttribute('data-velocidad') || '6', 10)) * 1000;
      if (!raiz._q4Ultimo) raiz._q4Ultimo = Date.now();
      if (Date.now() - raiz._q4Ultimo >= seg) ir(raiz, indice(raiz) + 1);
    });
  }, 500);
  document.addEventListener('shopify:block:select', function (e) {
    var raiz = e.target.closest && e.target.closest('[data-q4-banner]');
    if (!raiz) return;
    raiz._q4Pausa = true;
    var slides = pista(raiz).children;
    for (var k = 0; k < slides.length; k++) if (slides[k] === e.target || slides[k].contains(e.target)) ir(raiz, k);
  });

  /* ---------------- Carruseles con flechas (reseñas) ----------------
     Botones [data-q4-carr="ant|sig"] con aria-controls = id de la lista que se desliza. Avanzan una tarjeta y se apagan en los extremos. */
  function pasoCarr(lista) {
    var a = lista.children[0], b = lista.children[1];
    return a ? (b ? b.offsetLeft - a.offsetLeft : a.offsetWidth) : lista.clientWidth;
  }
  function estadoCarr(lista) {
    var max = lista.scrollWidth - lista.clientWidth - 2;
    document.querySelectorAll('[data-q4-carr][aria-controls="' + lista.id + '"]').forEach(function (b) {
      b.disabled = b.getAttribute('data-q4-carr') === 'ant' ? lista.scrollLeft <= 2 : lista.scrollLeft >= max;
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-q4-carr]');
    if (!b) return;
    var lista = document.getElementById(b.getAttribute('aria-controls'));
    if (!lista) return;
    lista.scrollBy({ left: (b.getAttribute('data-q4-carr') === 'ant' ? -1 : 1) * pasoCarr(lista), behavior: reducido ? 'auto' : 'smooth' });
  });
  document.addEventListener('scroll', function (e) {
    var l = e.target;
    if (!(l instanceof Element) || !l.id) return;
    if (document.querySelector('[data-q4-carr][aria-controls="' + l.id + '"]')) { clearTimeout(l._q4C); l._q4C = setTimeout(function () { estadoCarr(l); }, 60); }
  }, true);
  function carruseles() {
    document.querySelectorAll('[data-q4-carr="sig"]').forEach(function (b) { var l = document.getElementById(b.getAttribute('aria-controls')); if (l) estadoCarr(l); });
  }

  /* ---------------- «Leer más» del texto de colección ---------------- */
  function recortes() {
    document.querySelectorAll('[data-q4-recorte]').forEach(function (t) {
      var b = document.querySelector('[data-q4-leer][aria-controls="' + t.id + '"]');
      if (!b || t.classList.contains('q4-pie__cuerpo--abierto')) return;
      b.hidden = t.scrollHeight <= t.clientHeight + 4;
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-q4-leer]');
    if (!b) return;
    var t = document.getElementById(b.getAttribute('aria-controls'));
    if (!t) return;
    var abrir = b.getAttribute('aria-expanded') !== 'true';
    t.classList.toggle('q4-pie__cuerpo--abierto', abrir);
    b.setAttribute('aria-expanded', abrir ? 'true' : 'false');
    b.textContent = abrir ? b.getAttribute('data-menos') : b.getAttribute('data-mas');
  });

  /* ---------------- Cuenta regresiva ---------------- */
  function relojes() {
    document.querySelectorAll('[data-q4-reloj]').forEach(function (el) {
      var fin = Date.parse(el.getAttribute('data-q4-reloj'));
      var v = el.querySelector('[data-q4-reloj-valor]');
      if (isNaN(fin) || !v) return;
      var ms = fin - Date.now();
      if (ms <= 0) { el.querySelector('span').textContent = el.getAttribute('data-q4-reloj-fin') || ''; v.textContent = ''; return; }
      var d = Math.floor(ms / 86400000), h = Math.floor(ms / 3600000) % 24, m = Math.floor(ms / 60000) % 60;
      v.textContent = (d ? d + ' d ' : '') + h + ' h ' + (m < 10 ? '0' : '') + m + ' min';
    });
  }
  setInterval(relojes, 30000);

  /* ---------------- Filtros de colección (ronda 7) ----------------
     Celular: la barra «Filtrar · Ordenar · fichas» la dibuja el servidor (snippets/q4-filtros-cel.liquid), así que el
     tema la actualiza al filtrar sin borrarla. Aquí solo van los clics: cada ficha trae la URL sin ese filtro y se
     carga con el mismo mecanismo del tema (sin recargar la página).
     Computador: el tema decide qué filtros caben en la barra y cuáles van a «Más», pero solo lo mide al cargar. Al
     elegir un valor la píldora cambia de ancho y, sin volver a medir, «Más» quedaba escondido bajo la fila de filtros
     elegidos. medirBarra() le pide al tema que vuelva a medir después de cada cambio, sin mover el filtro abierto. */
  function cajon() { return document.getElementById('filters-drawer'); }
  function formFiltros() { return document.querySelector('facets-form-component[data-results-count]') || document.querySelector('facets-form-component'); }
  function irFiltros(url) {
    var form = formFiltros();
    if (form && typeof form.updateFiltersByURL === 'function') form.updateFiltersByURL(url);
    else window.location.href = url;
  }
  function abrirCajon() {
    var c = cajon();
    if (c && typeof c.open === 'function') { c.open(); return; }
    var b = document.querySelector('.facets-toggle .facets-toggle__button');
    if (b) b.click();
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-q4-filtrar], [data-q4-url], [data-q4-borrar]');
    if (!t || !t.closest('[data-q4-fcel]')) return;
    if (t.hasAttribute('data-q4-filtrar')) { abrirCajon(); return; }
    var url;
    if (t.hasAttribute('data-q4-borrar')) {
      var u = new URL(window.location.href);
      Array.from(u.searchParams.keys()).forEach(function (k) { if (k.indexOf('filter.') === 0) u.searchParams.delete(k); });
      u.searchParams.delete('page');
      url = u.toString();
    } else {
      url = new URL(t.getAttribute('data-q4-url'), window.location.origin).toString();
    }
    t.setAttribute('aria-busy', 'true'); // la ficha se atenúa mientras llega la grilla nueva
    irFiltros(url);
  });
  document.addEventListener('change', function (e) {
    var s = e.target;
    if (!s.matches || !s.matches('[data-q4-ordenar]')) return;
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', s.value);
    u.searchParams.delete('page');
    irFiltros(u.toString());
  });

  // Computador: el cajón de «Más» va encima de la página (q4.css); un clic fuera lo cierra, como cualquier panel.
  document.addEventListener('pointerdown', function (e) {
    var c = cajon();
    var dlg = c && c.querySelector('dialog[open]');
    if (!dlg || window.innerWidth < 750 || dlg.contains(e.target)) return;
    // el botón «Más» abre y cierra solo (está dentro del componente de la lista, en su shadow DOM)
    if (e.composedPath().some(function (n) { return n.getAttribute && n.getAttribute('part') === 'more'; })) return;
    if (typeof c.close === 'function') c.close();
  });

  // Ronda 11: «Más» abre el cajón en el primer filtro que no cupo en la barra (Marca, Precio o Tamaño) y no arriba, en
  // «Sexo», que ya está a la vista. El cajón trae todos los filtros en el mismo orden que la barra.
  document.addEventListener('click', function (e) {
    if (window.innerWidth < 750) return;
    if (!e.composedPath().some(function (n) { return n.getAttribute && n.getAttribute('part') === 'more'; })) return;
    var barra = document.querySelectorAll('.facets--horizontal .facets__item'), k = -1;
    for (var j = 0; j < barra.length; j++) if (barra[j].getAttribute('slot') === 'overflow') { k = j; break; }
    if (k < 0) return;
    var intentos = 0;
    (function bajar() {
      var c = cajon(), dlg = c && c.querySelector('dialog[open]');
      var lista = dlg && dlg.querySelector('.facets-drawer__filters'), it = dlg && dlg.querySelectorAll('.facets__item')[k];
      if (!lista || !it) { if (++intentos < 20) setTimeout(bajar, 25); return; }
      lista.scrollTop += it.getBoundingClientRect().top - lista.getBoundingClientRect().top;
    })();
  });

  // Computador: volver a medir la barra de filtros (evento «reflow» del componente overflow-list del tema).
  function medirBarra() {
    // Cantidad elegida en cada filtro: círculo bronce de la píldora (q4.css). El tema lo borra al redibujar; se repone aquí.
    document.querySelectorAll('.facets--horizontal .facets__item').forEach(function (it) {
      var w = it.querySelector('.facets__summary .facets__status-wrapper');
      if (!w) return;
      var n = it.querySelectorAll('.facets__inputs-list input[type="checkbox"]:checked').length;
      if (!n && Array.prototype.some.call(it.querySelectorAll('.price-facet__input'), function (i) { return i.value !== ''; })) n = 1;
      var v = n ? String(n) : null;
      if (w.getAttribute('data-q4-n') !== v) { if (v) w.setAttribute('data-q4-n', v); else w.removeAttribute('data-q4-n'); }
    });
    document.querySelectorAll('.facets--horizontal overflow-list').forEach(function (ol) {
      if (!ol.offsetWidth) return; // oculta (celular): el tema la mide cuando vuelve a verse
      // Solo después de la primera medición del tema, que fija el alto de una fila: sin ese alto la medida falla y
      // manda todos los filtros a «Más» (la trampa de ::part(list)).
      var lista = ol.shadowRoot && ol.shadowRoot.querySelector('[part="list"]');
      if (!lista || !lista.style.height) return;
      var abierto = ol.querySelector('.facets__item:not([slot="overflow"]) details[open]');
      ol.dispatchEvent(new CustomEvent('reflow', { detail: { lastVisibleElement: abierto ? abierto.closest('.facets__item') : null } }));
    });
  }
  // Ronda 8: una sola medición por cuadro, justo antes de pintar. Cada medición obliga al navegador a recalcular la página
  // (~50 ms) y antes corría en cada tanda de cambios del redibujo del tema: sumaba casi 1 s por filtro.
  var medirPendiente = 0;
  function medirPronto() {
    if (medirPendiente) return;
    medirPendiente = requestAnimationFrame(function () { medirPendiente = 0; medirBarra(); });
  }
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('.facets--horizontal')) medirPronto(); // el tema ya actualizó la píldora (su manejador corre antes)
  });
  // Cuando el tema vuelve a dibujar la sección (al filtrar u ordenar) se mide de nuevo, antes de pintar.
  function observarFiltros() {
    var f = formFiltros();
    var sec = f && f.closest('.shopify-section');
    if (!sec || sec._q4Obs) return;
    sec._q4Obs = new MutationObserver(medirPronto);
    sec._q4Obs.observe(sec, { childList: true, subtree: true });
  }

  /* Ronda 8: velocidad de los filtros. El tema hace cada cambio dentro de una «view transition», que deja la pantalla
     congelada mientras espera la grilla nueva del servidor (~0,8 s): el valor tocado no se marcaba y nada se movía hasta
     el final («tenía un tiempo de reacción»). En las páginas con filtros el cambio se hace sin congelar: el valor se
     marca al instante, la grilla se atenúa con una línea de carga arriba (q4.css) y la nueva aparece apenas llega. */
  var vtTema = typeof document.startViewTransition === 'function' ? document.startViewTransition.bind(document) : null;
  if (vtTema) {
    document.startViewTransition = function (cb) {
      if (!document.querySelector('facets-form-component')) return vtTema(cb);
      var hecho = Promise.resolve().then(function () {
        if (typeof cb === 'function') return cb();
        if (cb && typeof cb.update === 'function') return cb.update();
      });
      var fin = hecho.then(function () {}, function () {});
      return { finished: fin, ready: Promise.resolve(), updateCallbackDone: fin, types: new Set(), skipTransition: function () {} };
    };
  }
  var barraCarga = null;
  function cargando(si) {
    if (si && !barraCarga) {
      barraCarga = document.createElement('div');
      barraCarga.className = 'q4-carga';
      barraCarga.setAttribute('aria-hidden', 'true');
      document.body.appendChild(barraCarga);
    }
    document.documentElement.classList.toggle('q4-filtrando', si);
    clearTimeout(cargando._t);
    if (si) cargando._t = setTimeout(function () { cargando(false); }, 8000); // por si la respuesta nunca llega
  }
  ['shopify:collection:update', 'shopify:search:update'].forEach(function (n) {
    document.addEventListener(n, function (e) {
      cargando(true);
      var fin = function () { cargando(false); };
      if (e.promise && typeof e.promise.then === 'function') e.promise.then(fin, fin); else setTimeout(fin, 0);
    });
  });

  /* ---------------- Buscador del encabezado en computador (ronda 8) ----------------
     El campo de la derecha (snippets/search.liquid) es para escribir: con la primera letra se abre el buscador del tema
     con lo escrito y sus resultados al instante. Enter sin abrirlo va a la página de búsqueda. */
  function abrirBuscador(texto) {
    var c = document.getElementById('search-modal');
    var i = c && c.querySelector('input.search-input');
    if (!c || !i || typeof c.showDialog !== 'function') return false;
    c.showDialog();
    i.value = texto;
    i.focus();
    try { i.setSelectionRange(texto.length, texto.length); } catch (err) {}
    // Con inputType: el buscador del tema ignora los «input» sin él (ronda 10: al pegar un nombre no buscaba hasta borrar una letra)
    i.dispatchEvent(new InputEvent('input', { bubbles: true, inputType: 'insertText', data: texto }));
    return true;
  }
  document.addEventListener('input', function (e) {
    var campo = e.target;
    if (!campo.closest || !campo.closest('[data-q4-buscar]') || !campo.value.trim()) return;
    if (abrirBuscador(campo.value)) campo.value = '';
  });

  /* ---------------- Productos por página (ronda 10; ronda 13) ----------------
     «Ver 20/40» (snippets/q4-por-pagina.liquid). Lo elegido se guarda en el carrito como «colección:40» (atributo
     _por_pagina, lo lee sections/main-collection.liquid) y vale solo en esa colección: las demás abren con 20. Se recarga
     en la página 1 con la línea de carga y sin la animación de cambio de página del tema (con ella el cambio se veía raro). */
  var raizTienda = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function guardarPorPagina(valor) {
    return fetch(raizTienda + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { _por_pagina: valor } }) });
  }
  document.addEventListener('change', function (e) {
    var s = e.target;
    if (!s.matches || !s.matches('[data-q4-por-pagina]')) return;
    e.stopPropagation();
    s.disabled = true;
    cargando(true);
    var u = new URL(window.location.href);
    u.searchParams.delete('page');
    window.addEventListener('pageswap', function (ev) { if (ev.viewTransition) ev.viewTransition.skipTransition(); }, { once: true });
    var ir = function () { window.location.assign(u.toString()); };
    guardarPorPagina(s.value === '40' ? (s.getAttribute('data-q4-coleccion') || '') + ':40' : '').then(ir, ir);
  }, true);
  // Si la persona vuelve con «Atrás» y el navegador trae la página de su memoria, quedaba atenuada y con el selector bloqueado.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    cargando(false);
    document.querySelectorAll('[data-q4-por-pagina]').forEach(function (s) {
      s.disabled = false;
      var o = s.querySelector('option[selected]');
      if (o) s.value = o.value;
    });
  });
  // Lo elegido en otra colección se borra al entrar a esta (main-collection.liquid deja la marca): al volver allá, otra vez 20.
  var porPaginaLimpio = false;
  function limpiarPorPagina() {
    if (porPaginaLimpio || !document.querySelector('[data-q4-pp-limpiar]')) return;
    porPaginaLimpio = true;
    guardarPorPagina('');
  }

  /* ---------------- Lista de todas las marcas ---------------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-q4-marcas-todas]');
    if (!b) return;
    var lista = document.getElementById(b.getAttribute('aria-controls'));
    if (!lista) return;
    var abrir = lista.hidden;
    lista.hidden = !abrir;
    b.setAttribute('aria-expanded', abrir ? 'true' : 'false');
    var t = b.querySelector('[data-q4-texto]');
    if (t) t.textContent = abrir ? b.getAttribute('data-cerrar') : b.getAttribute('data-abrir');
    if (abrir) lista.scrollIntoView({ behavior: reducido ? 'auto' : 'smooth', block: 'nearest' });
  });

  function todo() {
    document.querySelectorAll('[data-q4-banner]').forEach(function (raiz) {
      marcar(raiz);
      if (reducido) raiz._q4Pausa = true; // con «reducir movimiento» parte en pausa
      pintarPausa(raiz);
    });
    relojes();
    observarFiltros();
    medirBarra();
    carruseles();
    recortes();
    limpiarPorPagina();
    barraFicha();
    preseleccionar();
  }

  /* ---------------- Ficha: talla «Más elegido» preseleccionada (P0, 19-oct) ----------------
     Si el enlace no trae ?variant= (anuncios, tarjetas), la ficha abre con el tamaño marcado con data-q4-preferida
     (snippets/variant-main-picker-decant-envio.liquid, ajuste «Preseleccionar el tamaño de la etiqueta 1»). Se elige
     con el mismo evento que un toque, así el tema actualiza precio, barra fija, regalos y URL. Una vez por página. */
  // UI-UX P1 #11: el selector llega con .q4-pre-pendiente (ninguna talla se ve elegida) hasta que termina la preselección
  function listoPre() { document.querySelectorAll('.q4-pre-pendiente').forEach(function (v) { v.classList.remove('q4-pre-pendiente'); }); }
  function preseleccionar() {
    if (/[?&]variant=/.test(location.search)) { listoPre(); return; }
    var input = document.querySelector('.product-details variant-picker input[data-q4-preferida]');
    if (!input || input.checked) { listoPre(); return; }
    if (input._q4Pre) return;
    input._q4Pre = true;
    var elegir = function () {
      if (input.checked || /[?&]variant=/.test(location.search)) { listoPre(); return; }
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      listoPre();
    };
    if (!window.customElements || !window.Promise) { elegir(); return; }
    // Espera a que estén definidos los componentes de la ficha que escuchan el cambio (precio, ahorro, regalos,
    // barra fija); si alguno no llega en 2,5 s, elige igual.
    var seccion = input.closest('.shopify-section') || document;
    var nombres = {};
    seccion.querySelectorAll('*').forEach(function (el) { if (el.localName.indexOf('-') > 0 && !customElements.get(el.localName)) nombres[el.localName] = true; });
    var esperas = Object.keys(nombres).map(function (n) { return customElements.whenDefined(n); });
    esperas.push(customElements.whenDefined('variant-picker'));
    Promise.race([Promise.all(esperas), new Promise(function (r) { setTimeout(r, 2500); })]).then(function () { setTimeout(elegir, 0); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todo); else todo();
  document.addEventListener('shopify:section:load', todo);

  /* ---------------- Íconos del botón «Agregar» (ronda 14) ----------------
     El check animado y el ícono de error venían repetidos en cada tarjeta (26 elementos por tarjeta). Ahora están una vez
     en <template id="q4-iconos"> (theme.liquid) y se copian al formulario que se toca, en fase de captura: antes de que el
     tema marque el botón como agregado (también cuando la barra fija de la ficha hace clic en el botón principal). */
  function iconosBoton(raiz) {
    var t = document.getElementById('q4-iconos');
    if (!t || !raiz) return;
    raiz.querySelectorAll('[data-q4-icono]').forEach(function (el) {
      if (el.firstElementChild) return;
      var fuente = t.content.querySelector('[data-q4-icono-fuente="' + el.getAttribute('data-q4-icono') + '"]');
      if (fuente && fuente.firstElementChild) el.appendChild(fuente.firstElementChild.cloneNode(true));
    });
  }
  ['pointerdown', 'keydown', 'click'].forEach(function (tipo) {
    document.addEventListener(tipo, function (e) {
      var f = e.target && e.target.closest && e.target.closest('product-form-component');
      if (f) iconosBoton(f);
    }, true);
  });

  /* ---------------- Barra fija de la ficha en el celular (ronda 15) ----------------
     El tema la deja siempre a la vista bajo 750 px. Aquí se muestra (body.q4-barra-ver, ver q4.css) solo cuando el botón
     principal ya quedó arriba de la pantalla y el pie no está a la vista. Además, Safari de iOS 26 a veces la dibuja más
     arriba del borde cuando se esconde su barra de herramientas: se mide contra visualViewport y se baja lo que sobra
     (--q4-barra-hueco, entre 0 y 140 px; en los demás navegadores da 0). Con ?q4barra=1 muestra las medidas arriba. */
  function barraFicha() {
    var celular = window.matchMedia('(max-width: 749px)');
    var sticky = document.querySelector('sticky-add-to-cart');
    var bar = sticky && sticky.querySelector('.sticky-add-to-cart__bar');
    if (!bar || sticky._q4Barra) return;
    var seccion = sticky.closest('.shopify-section');
    var form = seccion && seccion.querySelector('product-form-component[data-product-id="' + sticky.getAttribute('data-product-id') + '"]');
    var botones = form && form.closest('.buy-buttons-block');
    var pie = document.querySelector('footer') || document.querySelector('[class*="footer-group"]');
    if (!botones) return;
    sticky._q4Barra = true;
    var vv = window.visualViewport, cuadro = 0, debug = /[?&]q4barra=1/.test(location.search), caja;
    // Se mide en cada cuadro con desplazamiento (no con IntersectionObserver: un salto de abajo hasta arriba no lo avisa)
    function ajustar() {
      cuadro = 0;
      var pasado = botones.getBoundingClientRect().bottom <= 0;
      var pieVisible = !!pie && pie.getBoundingClientRect().top < innerHeight;
      var ver = pasado && !pieVisible;
      if (ver !== document.body.classList.contains('q4-barra-ver')) {
        document.body.classList.toggle('q4-barra-ver', ver);
        if (ver) setTimeout(pedir, 350); // vuelve a medir el hueco cuando termina de subir
      }
      var antes = parseFloat(bar.style.getPropertyValue('--q4-barra-hueco')) || 0, hueco = 0;
      tope(antes);
      if (vv && celular.matches && Math.abs(vv.scale - 1) < 0.02) {
        if (!document.body.classList.contains('q4-barra-ver')) return;
        var abajo = bar.getBoundingClientRect().bottom - antes;
        hueco = Math.round(vv.offsetTop + vv.height - abajo);
        if (hueco < 2 || hueco > 140) hueco = 0;
      }
      if (hueco !== antes) {
        if (hueco) bar.style.setProperty('--q4-barra-hueco', hueco + 'px'); else bar.style.removeProperty('--q4-barra-hueco');
        tope(hueco);
      }
      if (debug) {
        if (!caja) {
          caja = document.createElement('div');
          caja.style.cssText = 'position:fixed;top:0;left:0;z-index:2147483647;background:#000c;color:#fff;font:12px/1.3 monospace;padding:4px 6px;pointer-events:none';
          document.body.appendChild(caja);
        }
        caja.textContent = 'ih ' + innerHeight + ' · ch ' + document.documentElement.clientHeight + ' · vv ' + (vv ? Math.round(vv.height) + '+' + Math.round(vv.offsetTop) : '-') +
          ' · barra ' + Math.round(bar.getBoundingClientRect().bottom) + ' · hueco ' + hueco;
      }
    }
    // Altura que ocupa la barra desde el borde de abajo (--q4-barra-tope en <html>): la usa la píldora «Tu regalo»
    // del pop-up (q4-bienvenida.css) para quedar justo encima de la barra y no taparla.
    var topeAntes = '';
    function tope(h) {
      if (!document.body.classList.contains('q4-barra-ver')) return;
      var t = Math.round(bar.offsetHeight + (parseFloat(getComputedStyle(bar).bottom) || 0) - h) + 'px';
      if (t !== topeAntes) { topeAntes = t; document.documentElement.style.setProperty('--q4-barra-tope', t); }
    }
    function pedir() { if (!cuadro) cuadro = requestAnimationFrame(ajustar); }
    window.addEventListener('scroll', pedir, { passive: true });
    window.addEventListener('resize', pedir);
    if (vv) { vv.addEventListener('resize', pedir); vv.addEventListener('scroll', pedir); }
    if (celular.addEventListener) celular.addEventListener('change', pedir);
    pedir();
  }
})();

/* ---------------- UI-UX P1 (19-oct) ----------------
   Hoja «¿Qué tamaño elijo?» de la ficha (#10). Delegación sobre document: sigue andando cuando el tema vuelve a dibujar
   el selector al cambiar de talla. */
(function () {
  if (window.__q4p1) return;
  window.__q4p1 = true;
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var abrir = t.closest('[data-q4-ayuda-talla]');
    if (abrir) {
      e.preventDefault();
      var hoja = (abrir.closest('variant-picker') || document).querySelector('[data-q4-hoja-talla]');
      if (hoja && hoja.showModal && !hoja.open) { hoja.showModal(); document.documentElement.classList.add('q4bv-aparte'); }
      return;
    }
    var hojaAbierta = t.closest('dialog.q4-hoja');
    if (hojaAbierta && (t.closest('[data-q4-hoja-cerrar]') || t === hojaAbierta)) hojaAbierta.close();
  });
  document.addEventListener('close', function (e) {
    if (e.target && e.target.matches && e.target.matches('dialog.q4-hoja')) document.documentElement.classList.remove('q4bv-aparte');
  }, true);
})();

/* UI-UX P1 #28: «Ver N más» en las colecciones y la búsqueda. Pide la página siguiente con la API de secciones
   (solo esta sección), agrega sus tarjetas al final de la grilla y deja el botón apuntando a la que sigue.
   La dirección de la página no cambia (al recargar vuelve a la primera). Sin JavaScript, el botón queda oculto
   y siguen los números de página. */
(function () {
  if (window.__q4mas) return;
  window.__q4mas = true;
  function preparar() {
    document.querySelectorAll('[data-q4-mas][hidden]').forEach(function (caja) {
      caja.hidden = false;
      var nav = caja.parentElement && caja.parentElement.querySelector('.pagination');
      if (nav) nav.classList.add('q4-mas__nav');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', preparar); else preparar();
  // Los filtros vuelven a dibujar la grilla: se prepara de nuevo el botón nuevo
  new MutationObserver(function () { if (document.querySelector('[data-q4-mas][hidden]')) preparar(); })
    .observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('click', function (e) {
    var boton = e.target.closest && e.target.closest('[data-q4-mas-boton]');
    if (!boton || boton.getAttribute('aria-busy') === 'true') return;
    var caja = boton.closest('[data-q4-mas]');
    var seccion = boton.closest('.shopify-section');
    var grilla = seccion && seccion.querySelector('ul.product-grid');
    if (!grilla) return;
    var url = new URL(boton.getAttribute('data-url'), location.origin);
    url.searchParams.set('section_id', seccion.id.replace(/^shopify-section-/, ''));
    var texto = boton.textContent;
    boton.setAttribute('aria-busy', 'true');
    boton.textContent = 'Cargando…';
    fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nueva = doc.querySelector('ul.product-grid');
        if (!nueva) throw new Error('sin grilla');
        var primera = null;
        Array.prototype.slice.call(nueva.children).forEach(function (li) {
          if (li.tagName !== 'LI') return;
          // La tarjeta del pack a lo ancho ya está en la primera página
          if (li.querySelector('.q4-promo')) return;
          var nuevo = document.importNode(li, true);
          grilla.appendChild(nuevo);
          if (!primera) primera = nuevo;
        });
        var cajaNueva = doc.querySelector('[data-q4-mas]');
        var navNueva = doc.querySelector('.pagination');
        var nav = caja.parentElement.querySelector('.pagination');
        if (nav && navNueva) { nav.replaceWith(document.importNode(navNueva, true)); }
        if (cajaNueva) {
          cajaNueva.hidden = false;
          caja.replaceWith(document.importNode(cajaNueva, true));
          var n2 = document.querySelector('.pagination'); if (n2) n2.classList.add('q4-mas__nav');
        } else {
          caja.remove();
        }
        // El foco pasa a la primera tarjeta nueva (teclado y lectores de pantalla)
        var enlace = primera && primera.querySelector('a[href]');
        if (enlace) enlace.focus({ preventScroll: true });
      })
      .catch(function () {
        boton.removeAttribute('aria-busy');
        boton.textContent = texto;
        location.href = boton.getAttribute('data-url');
      });
  });
})();

/* UI-UX P1 #28: barra «Filtrar · Ordenar» fija en el celular. La barra trae arriba el conteo y los filtros elegidos;
   --q4-fcel-top la sube lo justo para que, fija, solo asomen los botones bajo el encabezado (que es fijo). */
(function () {
  if (window.__q4fcel) return;
  window.__q4fcel = true;
  var cel = window.matchMedia('(max-width: 749px)');
  var cuadro = 0;
  function medir() {
    cuadro = 0;
    var barra = document.querySelector('.collection-wrapper > .q4-fcel');
    if (!barra) return;
    if (!cel.matches) { barra.classList.remove('is-fijo'); return; }
    var botones = barra.querySelector('.q4-fcel__botones');
    var enc = document.querySelector('#header-component');
    var alto = enc ? Math.round(enc.getBoundingClientRect().bottom) : 0;
    if (alto < 0) alto = 0;
    // (getBoundingClientRect: con position: sticky la barra pasa a ser el offsetParent de los botones)
    var top = alto - (botones ? Math.round(botones.getBoundingClientRect().top - barra.getBoundingClientRect().top) : 0) + 8;
    var antes = barra.style.getPropertyValue('--q4-fcel-top');
    if (antes !== top + 'px') barra.style.setProperty('--q4-fcel-top', top + 'px');
    barra.classList.toggle('is-fijo', Math.round(barra.getBoundingClientRect().top) <= top + 1 && window.scrollY > 0);
  }
  function pedir() { if (!cuadro) cuadro = requestAnimationFrame(medir); }
  window.addEventListener('scroll', pedir, { passive: true });
  window.addEventListener('resize', pedir);
  if (cel.addEventListener) cel.addEventListener('change', pedir);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pedir); else pedir();
  // Al filtrar, el tema vuelve a dibujar la barra (cambia el alto de la línea de filtros elegidos)
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.q4-fcel, .facets')) setTimeout(pedir, 600); });
  document.addEventListener('change', function () { setTimeout(pedir, 600); });
})();

/* UI-UX P2 #33 (19-oct): «Vistos recientemente». Cada ficha anota en este navegador su identificador (localStorage
   «q4-vistos», los últimos 12, nada personal). La sección «Q4 · Vistos» de la ficha y las sugerencias del carrito
   (q4-carrito.js, con window.q4Vistos) muestran los anteriores con los datos al día de /products/<h>.js. */
(function () {
  if (window.q4Vistos) return;
  var CLAVE = 'q4-vistos', TOPE = 12;
  var RAIZ = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');
  var cache = {};
  function lista() {
    try {
      var v = JSON.parse(localStorage.getItem(CLAVE));
      return Array.isArray(v) ? v.filter(function (h) { return typeof h === 'string' && /^[a-z0-9-]+$/i.test(h); }) : [];
    } catch (e) { return []; }
  }
  function anotar(h) {
    if (!h) return;
    var v = lista().filter(function (x) { return x !== h; });
    v.unshift(h);
    try { localStorage.setItem(CLAVE, JSON.stringify(v.slice(0, TOPE))); } catch (e) { /* sin almacenamiento */ }
  }
  function datos(h) {
    if (!cache[h]) {
      cache[h] = fetch(RAIZ + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[h];
  }
  function plata(c) { return '$' + Math.round(c / 100).toLocaleString('es-CL'); }
  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  // Igual que la tarjeta del carrito: sin «Decant », la marca después de « - »; los packs dicen «Pack»
  function nombres(p) {
    var partes = (p.title || '').replace(/^decant\s+/i, '').split(' - ');
    var nombre = partes[0], marca = partes.length > 1 ? partes[partes.length - 1] : '';
    var pack = (p.tags || []).indexOf('Pack') > -1 || /pack/i.test(p.type || '');
    if (!marca) {
      if (pack) { marca = 'Pack'; nombre = nombre.replace(/^Pack\s+/i, ''); }
      else if (p.vendor && p.vendor !== 'Odorato') marca = p.vendor;
    }
    return { nombre: nombre, marca: marca, pack: pack };
  }
  function foto(p, ancho) {
    var src = p.featured_image || (p.images && p.images[0]) || '';
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + ancho;
  }
  // La talla más barata que queda y su descuento, redondeado hacia abajo como el sello de las tarjetas (P1 #27)
  function precio(p) {
    var vs = (p.variants || []).filter(function (v) { return v.available; });
    if (!vs.length) return null;
    var v = vs.reduce(function (a, b) { return b.price < a.price ? b : a; });
    var pct = v.compare_at_price > v.price ? Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
    return { v: v, varias: vs.length > 1, pct: pct };
  }
  window.q4Vistos = { lista: lista, anotar: anotar, datos: datos, nombres: nombres, foto: foto, precio: precio, plata: plata, esc: esc };

  function tarjeta(p) {
    var n = nombres(p), pr = precio(p), f = foto(p, 360);
    if (!pr) return '';
    return '<li class="q4-visto">' +
      '<a class="q4-visto__foto" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
        (f ? '<img src="' + esc(f) + '" alt="" loading="lazy" width="360" height="360">' : '') + '</a>' +
      '<p class="q4-visto__marca">' + (n.marca ? esc(n.marca) : '&nbsp;') + '</p>' +
      '<a class="q4-visto__nombre" href="' + esc(p.url) + '">' + esc(n.nombre) + '</a>' +
      '<p class="q4-visto__precio">' + (pr.varias ? '<span class="q4-visto__desde">Desde</span> ' : '') +
        '<span>' + plata(pr.v.price) + '</span>' +
        (pr.pct > 0 ? ' <span class="q4-visto__sello">−' + pr.pct + '&nbsp;%</span>' : '') + '</p>' +
      '</li>';
  }
  function pintar(sec) {
    if (sec._q4v) return;
    sec._q4v = true;
    var actual = sec.getAttribute('data-actual');
    var max = parseInt(sec.getAttribute('data-max'), 10) || 8;
    var hs = lista().filter(function (h) { return h !== actual; }).slice(0, max + 4);
    anotar(actual);
    if (!hs.length) return;
    Promise.all(hs.map(datos)).then(function (ps) {
      var html = ps.filter(function (p) { return p && p.available; }).slice(0, max).map(tarjeta).join('');
      var ul = sec.querySelector('[data-q4-vistos-lista]');
      if (!html || !ul) return;
      ul.innerHTML = html;
      sec.hidden = false;
      // las flechas se ponen al día con el evento de desplazamiento (carruseles de q4.js)
      requestAnimationFrame(function () { ul.dispatchEvent(new Event('scroll')); });
    });
  }
  function todos() { document.querySelectorAll('[data-q4-vistos]').forEach(pintar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', todos); else todos();
  document.addEventListener('shopify:section:load', todos);
})();
